import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { SelectEventsDialog } from '../../dialogs/select-events/select-events.dialog';


@Component({
  selector: 'app-select-events-button',
  templateUrl: './select-events-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectEventsButtonComponent
  extends WithDisposableSubject()  {
  @Input() classes?: string;
  @Input() selectedEventIds: string[] = [];
  @Output() selectionChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  dateRange?: Partial<{
    start: Date;
    end: Date;
  }>;
  keyword?: string;

  constructor(
    private _route: ActivatedRoute,
    private _dialog: MatDialog,
  ) {
    super();
  }


  getButtonLabel(selectedEvents) {
    if (!selectedEvents || selectedEvents.length === 0) { return 'Select specific events...'; }
    return `${selectedEvents.length} event${selectedEvents.length > 1 ? 's' : ''} selected`;
  }

  openSelectEventDialog() {
    const dialogRef = SelectEventsDialog.open(this._dialog,
      {
        data: {
          selectedEventIds: this.selectedEventIds,
          dateRange: this.dateRange,
          keyword: this.keyword
        }
      });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const { selectedEventIds, dateRange, keyword } = result;
        this.selectedEventIds = selectedEventIds;
        this.selectionChange.emit(selectedEventIds);
        if (dateRange) { this.dateRange = dateRange; }
        if (keyword) {
          this.keyword = keyword;
        }
      }
    });
  }
}
